// @ts-nocheck
import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'

import { ToggleFeature, features } from 'features/ToggleFeature'

import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import yn from 'yn'
import Helmet from 'react-helmet'
import { StoreSuggestion } from 'features/Suggestion'
import { Services } from 'features/Services'
import { BannersVSA } from 'features/Services/BannersVSA'
import { Mileage } from 'features/Services/Mileage'
import { MenuHomeContainer } from 'App/MainMenu/MenuMobile'
import {
  SliderContainer,
  ConexxeBanner,
  ConexxeBannerDFP
} from 'features/Slider'
import Showcase, {
  FilteredShowcase,
  CategoriesShowcase,
  BenefitsShowcase,
  BannersShowcase
} from 'Catalog/Showcase'
import { AccumulatePoints } from 'features/AccumulatePoints'
import { BestOffers } from 'features/BestOffers'
import MediaQuery from 'react-responsive'

const HomePage = ({ profile }) => {
  useEffect(() => {
    setTimeout(() => {
      window._etmc.push([
        'setUserInfo',
        {
          email: profile['custom:participant_id']
        }
      ])
      window._etmc.push(['setOrgId', '6422293'])
      window._etmc.push(['trackPageView'])
    }, 3000)
  }, [])
  return (
    <Fragment>
      <Helmet>
        <title>{`${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      <SliderContainer />
      {profile && yn(process.env.REACT_APP_HAS_TRADEMENU_HOME) && (
        <MenuHomeContainer />
      )}

      <ToggleFeature feature={features.TourGuide} />

      <Showcase showcaseType='5' identifier='home' />

      {yn(process.env.REACT_APP_HAS_BANNERS_SHOWCASE) && <BannersShowcase />}

      {yn(process.env.REACT_APP_HAS_CATEGORIES_SHOWCASE) && (
        <CategoriesShowcase />
      )}
      {yn(process.env.REACT_APP_HAS_FILTERED_SHOWCASE) && <FilteredShowcase />}
      {yn(process.env.REACT_APP_HAS_BEST_OFFERS) && <BestOffers />}
      {yn(process.env.REACT_APP_HAS_ACCUMULATE_BANNERS) && <AccumulatePoints />}
      {yn(process.env.REACT_APP_HAS_BENEFITS_SHOWCASE) && <BenefitsShowcase />}
      <MediaQuery maxWidth={1024}>
        {yn(process.env.REACT_APP_HAS_CONNEXXE_BANNER) && <ConexxeBanner />}
        {yn(process.env.REACT_APP_HAS_CONNEXXE_BANNER_DFP) && (
          <ConexxeBannerDFP />
        )}
      </MediaQuery>
      <MediaQuery minWidth={1025}>
        {yn(process.env.REACT_APP_HAS_CONNEXXE_BANNER) && <ConexxeBanner />}
        {yn(process.env.REACT_APP_HAS_CONNEXXE_BANNER_DFP) && (
          <ConexxeBannerDFP />
        )}
      </MediaQuery>

      {yn(process.env.REACT_APP_HAS_VOUCHER_SHOWCASE) && (
        <Showcase showcaseType='7' identifier='home' />
      )}
      {profile && (
        <Fragment>
          <Services />
          <Mileage />
        </Fragment>
      )}
      {yn(process.env.REACT_APP_HAS_STORES_SHOWCASE) && <StoreSuggestion />}
      {yn(process.env.REACT_APP_BANNERS_VSA) && <BannersVSA />}
    </Fragment>
  )
}

HomePage.propTypes = {
  profile: PropTypes.object
}

export default HomePage



// WEBPACK FOOTER //
// ./src/HomePage/HomePage.js